<template lang="pug">
  .b-change
    BaseStatus._item.old(:status="change.info.old")
    BaseStatus._item(:status="change.info.new")
</template>

<script>
import BaseStatus from '@/components/BaseStatus.vue';

export default {
  name: 'TaskChangeStatus',
  components: { BaseStatus },
  props: {
    change: Object,
  },
};
</script>

<style scoped lang="scss">
  .change {
    display: flex;
    gap: 22px;

    &__item {
      //padding: 1px 0;
    }
  }
</style>
